export default (
  value,
  words,
  withCount = false,
  nonBreaking = false,
  localeString = false
) => {
  const symbol = nonBreaking ? `\u00A0` : ' ';
  if (!value) return words[0];
  const doubleNum = Math.abs(value) % 100;
  const num = doubleNum % 10;
  const setValue = localeString ? Number(value).toLocaleString('ru') : value;
  if (doubleNum > 10 && doubleNum < 20)
    return (withCount ? setValue + symbol : '') + words[3];
  if (num > 1 && num < 5)
    return (withCount ? setValue + symbol : '') + words[2];
  if (num === 1) return (withCount ? setValue + symbol : '') + words[1];
  return (withCount ? setValue + symbol : '') + words[3];
};
